
(function newsCardsFrontend($, window) {
    $(document).on('cms.ready', ready);
    // $(document).ready(ready);

    // Nice-to-have: Placeholder elements while waiting for actual content

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    // TODO: This looks very wonky on between 768 and 1023
    let generalSlickSettings = {
        mobileFirst: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        responsive: [{
            breakpoint: 767, // >767 (tablet_portrait)
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },{
            breakpoint: 1023, // >1023 (tablet)
            settings: 'unslick'
            // settings: {
            //     slidesToShow: 4,
            //     slidesToScroll: 1,
            // }
        }]
    };

    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionNewsCards', function(evt, entry, $elm) {
                saveTemplate($elm);
                // Ditto slick settings (which are adjusted on a per-section basis)
                $elm.data('slickSettings', generalSlickSettings);

                loadNews(evt, entry, $elm);
            });
        } else {
            let $sections = $('.sectionNewsCards');

            $sections.each(function setupSection(i, elm) {
                let $elm = $(elm);
                saveTemplate($elm);
                // Ditto slick settings (which are adjusted on a per-section basis)
                $elm.data('slickSettings', generalSlickSettings);
            });

            // Set up intersect listener on section (delay GET until section is visible)
            $sections.on('cms.intersect', loadNews);
        }

    }

    function saveTemplate($elm) {
        let $template = $elm.find('.news-cards__template').detach();

        if ($template.prop('nodeName') === 'TEMPLATE') {
            let inner = $template.html();
            $template = $(inner);
        }

        // We want to refer to the template later, so save a reference on the section
        $elm.data('_template', $template);
    }

    function loadNews(event, entry, $section) {
        Contenda.log('loadNews', event, entry, $section);
        let $template = $section.data('_template'),
            $slider = $section.find('.news-cards__elements');

        $.get(
            'api/blog/newest',
            {  limit: 4 },
            function processBlogs(data) {
                let promises = [];

                $.each(data.rows, function setupTemplate(i, row) {
                    // Copy the template
                    let $elementTemplate = $template.clone();
                    // Remove template class
                    $elementTemplate.removeClass('news-cards__template');

                    // use alternative title if it is set
                    if (row.options && row.options.alternativeTitle && row.options.alternativeTitle.length > 0) {
                        row.title = row.options.alternativeTitle;
                    }

                    // Adjust data-* elements on the template to match the data received
                    for (let key in row) {
                        setValue($elementTemplate, key, row[key]);
                    }

                    // NTH: Better, more versatile handling of alt-text
                    let _images = $elementTemplate.find('img'); // img:not([alt]
                    if(_images.length > 0) {
                        _images.each(function addAltText(i, img) {
                            $(img).attr('alt', row.title);
                        })
                    }

                    if(row.imageUrl) {
                        // NTH: Better, more versatile handling of srcset
                        let _pictures = $elementTemplate.find('picture');
                        if (_pictures.length > 0) {
                            Contenda.setPictureSrcset(_pictures, row.imageUrl);
                        }
                    }

                    let $tagElement = $elementTemplate.find('.card__tags');
                    if($tagElement.length > 0) {
                        // Load blog tags
                        let tagPromise = $.get('api/tag/page/' + row.id, {limit: 4})

                        // Add tags to element
                        tagPromise.then(function addTags(tagData) {
                            // console.log('tag loaded for', row.id);
                            $.each(tagData, function (i, tag) {
                                let tagName = tag.name;
                                $tagElement.append(
                                    '<div class="card__top--circle tag">' + tagName + '</div>'
                                );
                            });
                        });

                        // Keep track of all our tag promises
                        promises.push(tagPromise);
                    }


                    // Add the element/card to the slider
                    $elementTemplate.appendTo($slider);
                });

                Promise.all(promises).then(function allTagsLoaded() {
                    // console.log('all tags loaded -- setup slider');
                    setupSlider($section);
                })
            }
        );
    }

    function setValue($elementTemplate, key, value) {
        if($.isArray(value)) {
            for(var _key in value) {
                setValue($elementTemplate, key + '.' + _key, value[_key]);
            }
            return;
        }

        // No value? Do nothing
        if (!value) return;

        // Get the matching sub-element to modify
        let elm = $elementTemplate.find('[data-field="' + key + '"]');

        switch (key) {
            case 'imageUrl':
                elm.attr('src', value + '?opt=true');
                break;
            case 'summary':
                let truncate_length = 160,
                    summary = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
                if (summary.length > truncate_length) {
                    summary = summary.substring(0, truncate_length-3) + '...';
                }
                elm.html(summary);
                break;
            case 'reference':
                elm.attr('href', value);
                break;
            case 'publishDate':
                var date = new Date(value);
                var month = new Intl.DateTimeFormat('da-DA', {
                    month: 'long'
                }).format(date);

                // DD. Month YYYY
                var dateString = date.getDate() + '. ' + month + ' ' + date.getFullYear();

                elm.html(dateString);
                break;
            default:
                elm.html(value);
                break;
        }
    }

    function setupSlider($section) {
        let slickSettings = $section.data('slickSettings');

        // Set prev and nextarrow to __prev and __next's html.
        slickSettings.prevArrow = $section.find('.news-cards__prev').detach().get(0).outerHTML;
        slickSettings.nextArrow = $section.find('.news-cards__next').detach().get(0).outerHTML;

        // (re-)Append the arrows to the navigation elm
        slickSettings.appendArrows = $section.find('.news-cards__navigation');

        let $slider = $section.find('.news-cards__elements');

        // In this case - because we don't have any angular bindings on the slider itself
        // we do not need to check if we're logged in or not
        // We can just initialize the slick slider

        $slider.hide();
        if($slider.hasClass('slick-initialized')) {
            // Unslick in case it has been initialized before
            $slider.slick('unslick');
        }
        setTimeout( function reSlick() {
            $slider.show();
            $slider.slick(slickSettings);
        }, 100);
    }

})(jQuery, window);